import { Controller } from "@hotwired/stimulus";

// Hides the fade overlay and the "Ver mais…" link when the body is short enough
// to be fully visible — otherwise a two-line entry renders behind a gradient and
// looks truncated when it is not.
//
// Overflow can only be measured after layout, so this starts in the clamped
// state (correct for the common case, and correct with JS disabled) and clears
// it when the content turns out to fit.
export default class extends Controller {
	static targets = ["body", "fade", "more"];

	connect() {
		this.render();
		this.observer = new ResizeObserver(() => this.render());
		this.observer.observe(this.bodyTarget);
	}

	disconnect() {
		this.observer?.disconnect();
	}

	render() {
		if (!this.hasBodyTarget) return;

		// 1px of slack: sub-pixel line heights can report a scrollHeight a hair
		// taller than clientHeight even when nothing is actually cut off.
		const overflowing = this.bodyTarget.scrollHeight - this.bodyTarget.clientHeight > 1;

		if (this.hasFadeTarget) this.fadeTarget.classList.toggle("hidden", !overflowing);
		if (this.hasMoreTarget) this.moreTarget.classList.toggle("hidden", !overflowing);
	}
}
